import CollapsibleListControlled from './CollapsibleListControlled';

export default CollapsibleListControlled;
